import { render, staticRenderFns } from "./goodsView.vue?vue&type=template&id=38ec2064&scoped=true"
import script from "./goodsView.vue?vue&type=script&lang=js"
export * from "./goodsView.vue?vue&type=script&lang=js"
import style0 from "./goodsView.vue?vue&type=style&index=0&id=38ec2064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec2064",
  null
  
)

export default component.exports